var morphs = [];
var time = 0;
var M = {
	size: 0,
	angle: 0,
	num: 0
}
var isFirstTime = true;
var pi 		= Math.PI/180;
var colors 	= ["#7f6f00", "#EBBE00","#7f6f00","#EBBE00"];
var urls 	= [];
var morph = {
	url 	: "/json/works.json",
	current	: 0,
	max		: 0,
	init: function(){
		var param 		= {};
		var isCanvasArry 	= [1,0,0,0,0,0,0];
		var bgClsArry	= [0,1,2,3,4,5];
		common.load(morph.url, param).done(function(json){
			var works = json.works[0];
			morph.max = works.length;
			var HTML 		= '';
			var count 		= 0,
				bgCount 	= 0,
				cvsCount 	= 0;
			urls = [];
			//背景、canvasのarrayを作成
			for(var j = 0; j < morph.max; j++){
				bgClsArry.push(bgClsArry[count]);
				isCanvasArry.push(isCanvasArry[count]);
				count++;
				if(count >= isCanvasArry.length){
					count = 0;
				}
			}
			
			var cvs 	= shuffle(isCanvasArry);
			var bgCls 	= shuffle(bgClsArry);
			var imgArry = [];
			//HTMLを作成
			for(var i = 0; i < morph.max; i++){
				var w = works[i];
				urls.push(w.postURL);
				w.id = i;
				posts.push(w);
				//背景画像かcanvasか
				if(cvs[i] === 1){
					var cvsHTML  	= '<canvas id="c' + cvsCount + '"></canvas>';
					var bgClass 	= "";
					cvsCount++;
				}else{
					var cvsHTML 	= '';
					var bgClass 	= "bg" + bgCls[i];
				}
				var randomPosY 	= Math.floor(Math.random()*(30 - 0) + 0);
				var randomPosX 	= Math.floor(Math.random()*10 - 5);
				var imgsrc 		= "/assets/images/works/" + w.image;
				/*
				HTML 	+= '<li class="a ' + bgClass + '" data-pos-x="' + randomPosX + '" data-pos-y="' + randomPosY + '">'
						+ '<a href="javascript:void(0);" data-url="' + w.postURL + '" title="' + w.title + '">'
					 	+ '<div class="bg_img">'
						+ '<div class="bg">'
						+ cvsHTML
						+ '</div>'
						+ '<div class="img">'
						+ '<figure style="background-image: url(/assets/images/works/' + w.image + ');"></figure>'
						+ '</div>'
						+ '</div>'
						+ '<div class="txt">'
						+ '<h3>' + w.title + '</h3>'
						+ '<p>' + w.client + '</p>'
						+ '</div></a>'
						+ '</li>';
				*/
				HTML 	+= '<li class="a ' + bgClass + '" data-pos-x="' + randomPosX + '" data-pos-y="' + randomPosY + '">'
						+ '<div class="inr">'
						+ '<a href="javascript:void(0);" data-url="' + w.postURL + '" title="' + w.title + '">'
					 	+ '<div class="bg_img">'
						+ '<div class="bg">'
						+ cvsHTML
						+ '</div>'
						+ '<div class="img">'
						+ '<figure style="background-image: url(/assets/images/works/' + w.image + ');"></figure>'
						+ '</div>'
						+ '</div>'
						+ '</a>'
						+ '<div class="txt">'
						+ '<h3>' + w.title + '</h3>'
						+ '<p>' + w.client + '</p>'
						+ '</div></div>'
						+ '</li>';
				imgArry.push(imgsrc);
			}
			var hash 	= location.hash;
			var hashAry = hash.split("/");
			var hashLen = hashAry.length;
			var lastHash = hashAry[hashLen - 1];
			post.folder = hashAry[hashLen - 2];
			post.id 	= getNum(lastHash);
			if(post.id){
				var p = posts[post.id];
				var col1 	= p.col1image;
				var col2 	= p.col2image;
				//col1
				for(var i = 0; i < col1.length; i++){
					var img = "/assets/images/works/" + col1[i];
					imgArry.push(img);
				}
				//col2
				for(var j = 0; j < col2.length; j++){
					var img = "/assets/images/works/" + col2[j];
					imgArry.push(img);
				}
			}
			
			$("#grid_inner ul").html(HTML);
			common.resize();
			preload.startLoad(imgArry.length,imgArry).done(function(){
				//console.log("all done");
				//return false
				post.init();
				morph.start();
				setTimeout(function(){
					$("body").removeClass("isLoading");
					common.resize();
					$("#loading").fadeOut(600, function(){
						setTimeout(function(){
							common.resize();
							preload.reset();
							$("#loading").removeClass();
						},400);
					});
				},300);
			});
		});
	},
	start: function(){
		$("#block_grid canvas").each(function(i){
			var canvas 		= document.getElementById("c" + i);
			var ctx 		= canvas.getContext("2d");
			ctx.lineJoin 	= 'round';
			var _m = object(M);
			if(isSmallScreen){
				var sizeMax = Math.floor(($("#block_grid .bg").width() - $("#block_grid .img").width())/4*.8);
			}else{
				var sizeMax = 12;
			}
			_m.size 	= Math.floor(Math.random()*(sizeMax - 10) + 10);
			_m.angle 	= 2;
			_m.num 		= Math.floor(Math.random()*(6 - 3) + 3);
			_m.target = ctx;
			morphs.push(_m);
		});
		
		$("body").removeClass("disable");
		common.resize();
		setInterval(function(){
			time++;
			morph.makeCircle();
		},1000/30);
	},
	resize: function(){
		if(isSmallScreen){
			var _w = Math.floor($("#block_grid ul").width());
		}else{
			var _w = Math.floor($("#block_grid .bg").width()*.95);
		}
		$("#block_grid canvas").each(function(i){
			var size = _w*devicePixelRatio;
			$(this).attr("width", size + "px");
			$(this).attr("height", size + "px");
			var bw = size / devicePixelRatio;
			var m = Math.floor(bw)/-2;
			$(this).css({
				"width" : bw + "px",
				"height": bw + "px",
				"margin-top": m + "px",
				"margin-left": m + "px"
			});
		});
		$("#block_grid li").each(function(i){
			var _x = $(this).attr("data-pos-x");
			var _y = $(this).attr("data-pos-y");
			if(isSmallScreen){
				$(this).css({
					"transform" : ""
				});
			}else{
				$(this).css({
					"transform" : "translate3d(" + _x + "%, " + _y + "%, 0)"
				});
			}
		})
	},
	makeCircle: function(){
		if(isSmallScreen){
			var _w = Math.floor($("#block_grid ul").width())*devicePixelRatio;
		}else{
			var _w = Math.floor($("#block_grid .bg").width()*.95)*devicePixelRatio;
		}
		$("#block_grid canvas").each(function(i){
			var move = morphs[i].size*devicePixelRatio;
			var half = Math.floor(_w/2);
			var c = morphs[i].target;
			c.clearRect(0,0,_w,_w);
			for(var n = 0; n < 2; n++){
				morph.drawCircle(c, n, half, move, morphs[i].num, i);
			}
		});
	},
	drawCircle: function(c, n, half, move, num, i){
		var r 		= half;
		var angle 	= morphs[i].angle;
		
		if(n === 0){
			var addYPos 	= -5*devicePixelRatio;
		}else if(n === 1){
			var addYPos 	= 5*devicePixelRatio;
		}
		var speed 		= -time*.03;
		c.moveTo(0,0);
		c.fillStyle = colors[n];
		c.beginPath();
		if(isSmallScreen){
			var hankei = r*.85;
		}else{
			var hankei = r*.90;
		}
		for(var i = 0; i < 360; i=i+angle){
			var rad 	= i*pi;
			var baseX 	= hankei*Math.cos(rad) + r;
			var baseY 	= hankei*Math.sin(rad) + r;
			var t 		= Math.sin(speed+rad);
			var addX 	= t*move*.5*Math.cos(rad*num);
			var addY 	= t*move*Math.sin(rad*num);
			//var addY 	= 0;
			var x = baseX + addX;
			var y = baseY + addY - addYPos;
			c.lineTo(x, y);
		}
		c.closePath();
		c.fill();
	}
}
function getNum(postID){
	var num = 0;
	$.each(urls,function(index,val){
		if(postID === val){
			num = index;
		}
	});
	return num;
}
function shuffle(array) {
	var n = array.length, t, i;

	while (n) {
		i = Math.floor(Math.random() * n--);
		t = array[n];
		array[n] = array[i];
		array[i] = t;
	}
	return array;
}